const C = require("../constants");

const selectWaiter = (data) => {
    return {
        type: C.WAITER_SELECT,
        data
    }
};

export {selectWaiter};


// WEBPACK FOOTER //
// ./src/actions/WaiterSelectActions.js